import { css } from '@emotion/react';

export const defaultTheme = {
  input: css`
    height: 34px;
    width: 220px;
    margin-left: 12px;
    font-size: 15px;
    font-family: inherit;
    background-color: #333;
    border: none;
    color: #ddd;
    text-align: left;
    outline: none;
    overflow-x: auto;
    white-space: nowrap;
    resize: none;
    line-height: 34px;
    cursor: text;
    -webkit-user-select: text;
    user-select: text;
    &::-webkit-scrollbar {
      display: none;
    }
    &::-moz-selection {
      color: #fff;
      background-color: #3297fd;
    }
    &::selection {
      color: #fff;
      background-color: #3297fd;
    }
    &:focus {
      outline: none;
    }
    &::placeholder {
      color: #888;
    }
  `,

  inputInvalid: css`
    color: #ddd;
  `,

  link: css`
    color: #2996da;
    text-decoration: underline;
  `,

  buttonWrapper: css`
    display: flex;
    right: 0;
    padding: 0 0.5rem;
  `,
  button: css`
    color: #ddd;
    cursor: pointer;
    font-size: 1rem;
    white-space: nowrap;
    margin-left: 0.25rem;
    &:hover {
      color: #fff;
    }
  `,
};
